import { ACCENT, illustrationA11y, lineStyle } from './static-art';

/** One drawing, framed per use: each frame keeps the crop and the line weight its original export had. */
const FRAMES = {
	card: { width: 196, height: 146, viewBox: '0 0 196 146', stroke: 1 },
	tight: { width: 75, height: 55, viewBox: '14.3682 18.6132 153.2651 112.3944', stroke: 0.82031 },
} as const;

export function DonationWidgetIllustration(props: {
	className?: string;
	label?: string;
	ink?: string;
	frame?: keyof typeof FRAMES;
}) {
	const frame = FRAMES[props.frame ?? 'card'];
	const line = lineStyle(props.ink, frame.stroke);
	return (
		<svg
			width={frame.width}
			height={frame.height}
			viewBox={frame.viewBox}
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M161.142 19.0234H20.8619C17.5026 19.0234 14.7793 21.7467 14.7793 25.1061V122.51C14.7793 125.869 17.5026 128.593 20.8619 128.593H161.142C164.501 128.593 167.224 125.869 167.224 122.51V25.1061C167.224 21.7467 164.501 19.0234 161.142 19.0234Z"
				{...line}
			/>
			<path d="M14.7793 29.4336H167.222" {...line} />
			<path d="M54.5 106.234H127.5" {...line} />
			<path d="M64.4336 112.699H117.565" {...line} />
			<path
				d="M113.908 46.3419C104.339 39.1047 94.6598 47.8144 91.3129 51.4033C90.6259 52.1395 89.4713 52.1785 88.731 51.4956C78.9426 42.4372 70.7436 44.7854 66.6728 47.0412C64.5994 48.1917 63.0326 50.0518 62.2041 52.2748C58.7773 61.4788 66.1847 72.3274 73.8772 80.4362L78.6022 85.2986C82.8781 89.1028 87.2462 92.2815 89.0325 93.5468C89.662 93.9939 90.5049 93.9959 91.1407 93.5571C114.007 77.7312 126.73 56.038 113.906 46.3399L113.908 46.3419Z"
				fill={ACCENT}
			/>
		</svg>
	);
}
